<div class="limiter">
	<div class="container-login100">
		<div class="wrap-login100">
			<div class="login100-pic " data-tilt="">
				<img src="../../../assets/Logo.png">
			</div>
			<form class="login100-form validate-form">
				<span class="login100-form-title">
					Complete Your Account
				</span>
				<div class="wrap-input100 validate-input" data-validate="Valid email is required: ex@abc.xyz">
					<input class="input100" type="password" name="email"  [(ngModel)]="completeAccountDetails.password" placeholder="Password" autocomplete="off"
						style="background-image: url(&quot;data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAASCAYAAABSO15qAAAAAXNSR0IArs4c6QAAAPhJREFUOBHlU70KgzAQPlMhEvoQTg6OPoOjT+JWOnRqkUKHgqWP4OQbOPokTk6OTkVULNSLVc62oJmbIdzd95NcuGjX2/3YVI/Ts+t0WLE2ut5xsQ0O+90F6UxFjAI8qNcEGONia08e6MNONYwCS7EQAizLmtGUDEzTBNd1fxsYhjEBnHPQNG3KKTYV34F8ec/zwHEciOMYyrIE3/ehKAqIoggo9inGXKmFXwbyBkmSQJqmUNe15IRhCG3byphitm1/eUzDM4qR0TTNjEixGdAnSi3keS5vSk2UDKqqgizLqB4YzvassiKhGtZ/jDMtLOnHz7TE+yf8BaDZXA509yeBAAAAAElFTkSuQmCC&quot;); background-repeat: no-repeat; background-attachment: scroll; background-size: 16px 18px; background-position: 98% 50%;">
					<span class="focus-input100"></span>
					<span class="symbol-input100">
						<i class="fa fa-lock" aria-hidden="true"></i>
					</span>
					<span *ngIf="validationErrors.password !== ''" class="text-danger text-nowrap">{{validationErrors.password}}</span>
				</div>
				<div class="wrap-input100 validate-input" data-validate="Password is required">
					<input class="input100" type="password" name="pass" placeholder="Confirm Password"  [(ngModel)]="completeAccountDetails.confirmPassword" autocomplete="off"
						style="background-image: url(&quot;data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAASCAYAAABSO15qAAAAAXNSR0IArs4c6QAAAPhJREFUOBHlU70KgzAQPlMhEvoQTg6OPoOjT+JWOnRqkUKHgqWP4OQbOPokTk6OTkVULNSLVc62oJmbIdzd95NcuGjX2/3YVI/Ts+t0WLE2ut5xsQ0O+90F6UxFjAI8qNcEGONia08e6MNONYwCS7EQAizLmtGUDEzTBNd1fxsYhjEBnHPQNG3KKTYV34F8ec/zwHEciOMYyrIE3/ehKAqIoggo9inGXKmFXwbyBkmSQJqmUNe15IRhCG3byphitm1/eUzDM4qR0TTNjEixGdAnSi3keS5vSk2UDKqqgizLqB4YzvassiKhGtZ/jDMtLOnHz7TE+yf8BaDZXA509yeBAAAAAElFTkSuQmCC&quot;); background-repeat: no-repeat; background-attachment: scroll; background-size: 16px 18px; background-position: 98% 50%;">
					<span class="focus-input100"></span>
					<span class="symbol-input100">
						<i class="fa fa-lock" aria-hidden="true"></i>
					</span>
					<span *ngIf="validationErrors.confirmPassword !== ''" class="text-danger">{{validationErrors.confirmPassword}}</span>
				</div>
				<div class="container-login100-form-btn">
					<button class="login100-form-btn" (click)="submitData()">
						Submit Details
					</button>
				</div>
				<div class="text-center p-t-12" style="margin-top:20px; ">
					<span class="txt1">
						{{passwordComplexityRules}}
					</span>
				</div>
			</form>
		</div>
	</div>
	<!-- <div class="login-div position-absolute top-50 start-50 translate-middle">
		<div class="login-div-left">
			<img src="../../../assets/Logo.png" style="vertical-align: middle;">
		</div>
		<div class="login-div-right position-relative">
			<h4 class="mx-3 mt-3 pb-3">Complete Your Account</h4>
			<form class="login-form mx-3">
					<div class="row pb-3 pt-2">		
						<div class="col-12">
							<div class="form-group">
								<label>Password:</label>
								<input class="form-control shadow-none" type="password" name="password" [(ngModel)]="completeAccountDetails.password" id="password">
								<span *ngIf="validationErrors.password !== ''" class="text-danger text-nowrap">{{validationErrors.password}}</span>
							</div>
						</div>
						<div class="col-12">
							<div class="form-group">
								<label>Confirm Password:</label>
								<input class="form-control shadow-none" type="password" name="confirmPassword" [(ngModel)]="completeAccountDetails.confirmPassword" id="confirmPassword">
								<span *ngIf="validationErrors.confirmPassword !== ''" class="text-danger text-nowrap">{{validationErrors.confirmPassword}}</span>
							</div>
						</div>
						<div class="col-12">
							<p>{{passwordComplexityRules}}</p>
						</div>
						<div class="col-12">
							<div class="form-group">
								<button class="btn btn-block text-uppercase shadow-none w-100 login-button mb-3" (click)="submitData()">Submit Details</button>
							</div>
						</div>
					</div>
			</form>
			<span class="position-absolute bottom-0 start-0 mb-1 mx-3">{{copyright}}</span>
		</div>
	</div> -->
